"use client";

import * as LabelPrimitive from "@radix-ui/react-label";
import { Primitive } from "@radix-ui/react-primitive";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/common/helpers/utils";

const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 mb-2",
);

type LabelProps = React.ComponentProps<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants> & {
    /**
     * When true, text selection is allowed.
     */
    allowSelection?: boolean;
  };

const Label = ({ className, allowSelection = false, ref, ...props }: LabelProps): React.ReactElement => {
  const Component = allowSelection ? Primitive.label : LabelPrimitive.Root;

  return <Component ref={ref} className={cn(labelVariants(), className)} {...props} />;
};
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
